export const REPORT_TITLE = {
  TITLE: 'Reports',
  READY: 'are ready',
  PROGRESS: 'are in progress',
};

export const REPORT_STATUS = {
  PROGRESS: 'remaining',
  COMPLETED: 'completed',
  IN_PROGRESS: 'In-Progress'
};

export const REPORT_FOOTER = {
  MESSAGE:'Partial reports can be accessed once ready',
  CTA: 'View Details'
};
